export default __webpack_public_path__ + "static/media/raw.1fa46b56.svg";